import { LuFlag, LuGlobe, LuRoute, LuTrophy } from "react-icons/lu";
import { MISSIONS, RACES } from "../../shared/games/verden";
import type { GameProps } from "../pages/Match";
import { Link } from "../router";

/** What /kamp/:id shows for a Fri Verden trip: the world itself lives on /verden, so this is the trip's score card. */
export function VerdenSummary(p: GameProps) {
  const st = p.view.state;
  const b = st.board;
  const over = !!st.over;
  const me = st.stats?.[0];
  const missions = MISSIONS.filter((m) => b.missions?.[m.id]);
  const races = RACES.filter((r) => b.races?.[r.id]);
  return (
    <div className="card stack" aria-label="Din tur i Fri Verden">
      <div className="row between">
        <h2 style={{ margin: 0 }}><LuGlobe aria-hidden="true" size={22} /> {over ? "Din tur er slut" : "Din tur er i gang"}</h2>
        {!over && <Link to="/verden" className="btn lime">Tilbage til verden</Link>}
      </div>
      <div className="statline"><span>Rigtige svar</span><b>{me?.correct ?? 0} / {me?.answered ?? 0}</b></div>
      <div className="statline"><span>Stop på missioner</span><b>{b.stops ?? 0}</b></div>
      <div className="statline"><span>Omgange kørt</span><b>{b.laps ?? 0}</b></div>
      <div className="statline"><span>Point</span><b>{st.liveScore ?? st.score ?? 0}</b></div>
      {missions.length > 0 && (
        <div className="stack" style={{ gap: 6 }}>
          <h3 className="sec-sub"><LuRoute aria-hidden="true" size={16} /> Missioner klaret</h3>
          {missions.map((m) => <div key={m.id} className="statline"><span>{m.title}</span><b>{b.missions[m.id]}×</b></div>)}
        </div>
      )}
      {races.length > 0 && (
        <div className="stack" style={{ gap: 6 }}>
          <h3 className="sec-sub"><LuFlag aria-hidden="true" size={16} /> Ræs kørt</h3>
          {races.map((r) => <div key={r.id} className="statline"><span>{r.title}</span><b><LuTrophy aria-hidden="true" size={14} /> nr. {b.races[r.id].place ?? "–"}</b></div>)}
        </div>
      )}
    </div>
  );
}
